const ROUTES = {

    DASHBOARD: "/dashboard",
    LOGIN: "/login",
    RESESTPASSWORD: "/reset-password",
    CHANGEPASSWORD: "/change-password",
    RESESTPASSWORDEMAIL: "/reset-password-email",
    FORMS: "/forms",
    ADDFORM: "/form/create",
    FORMDETAIL: "/form/:id",
    AGENTS: "/agents",
    ADDAGENTS: "/agent/create",
    ADMINS: "/admins",
    ADDADMINS: "/admin/create",
    MAPS: "/maps",
    RESPONSES: "/form/responses",
    RESPONSEDETAIL: "/form/responses/:id",

    FARMERDASHBOARD: "/farmerdashboard"
}

const ROUTESGROUP = {
    FORMS: [ROUTES.FORMS, ROUTES.ADDFORM,  ROUTES.RESPONSEDETAIL, ROUTES.FORMDETAIL],
    AGENTS: [ROUTES.AGENTS, ROUTES.ADDAGENTS],
    ADMINS: [ROUTES.ADMINS, ROUTES.ADDADMINS],
}

export default ROUTES;

export {
    ROUTESGROUP
};